import React, { Fragment, useRef, useState ,useEffect } from "react";
import {Link} from "react-router-dom"
import "./styles.css";
import CarouselTopProducts from "../../components/carouselTopProducts";
import { useContext } from "react";
import AppContext from "../../context";
import Categories from "../../components/Categories/";
import CarouselProductsTopSale from "../../components/CarouselProductsTopSale";
import BannerProduct from "../../components/BannerProduct";
import BannerProductImg from "../../components/BannerProductImg"

const Home: React.FC = () => {
  const data = useContext(AppContext.AppCtx); 
  const categories: { name: string; img: string }[] = data.Categories
  const Ref = useRef<HTMLHeadingElement>(null)
  const {setPositionY, yPosition} = data
  useEffect(() => {
    const handleScroll = () => {
      const div:any = Ref.current;
      const { y } = div.getBoundingClientRect();
      setPositionY(y)
    };
    window.addEventListener("scroll", handleScroll);
    return () => {
      window.removeEventListener("scroll", handleScroll);
    };
  }, []);

  return (
    <div ref={Ref} className="container">
      <div className="headerBackground"></div>
      <CarouselTopProducts  />
      <BannerProductImg img={"https://res.cloudinary.com/ddoltb8nf/image/upload/v1662425004/just/WhatsApp_Image_2022-09-05_at_7.27.31_PM_qlywax.jpg"}/>
      <div className="containerCategoriasHome">
        <h1>CATEGORIAS</h1>
        <div ref={Ref} className="categories">
        {categories ? (
          categories.map((category) => <Categories key={category.name} category={category} />)
        ) : (
          <></>
        )}
      </div>
      </div>

      <BannerProduct/>
      <CarouselProductsTopSale/>
      <BannerProductImg img={"https://res.cloudinary.com/ddoltb8nf/image/upload/v1662424664/just/WhatsApp_Image_2022-09-05_at_7.29.36_PM_s7cyi7.jpg"}/>
    </div>
  );
};

export default Home;
